export default __webpack_public_path__ + "portal/static/media/Modular.573c94a0.svg";